import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './MovuRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class MovuRobotics_pallet_induction_on_successService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { licensePlateId?: number, locationId?: number, warehouseId?: number, taskId?: number, messageStorageId?: string, messageTransactionId?: string }): Promise<void> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

